import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { Card, CardBody, Nav, Container, Row, Col, Modal, Button, Form, DropdownButton, Dropdown, Collapse, Badge, Spinner } from "react-bootstrap";
import { Stack } from "@mui/material";
import Select from "react-select";
import { Formik } from "formik";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { ModalAllder } from "layouts/ModalAllder";
import { TagsInput } from "react-tag-input-component";
import DownloadExcelLoading from "utils/DownloadExcelLoading";
import DataTableLayout from "layouts/DatatableLayout";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import RowExpansion from "layouts/RowExpansion";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { initState } from "mocks/poData";
import moment from "moment";
import "moment/locale/th";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { getDiscountValue, NumberFormat, WDA, getPrefixName, filterTextAndNum } from "utils/HelperFunction";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import ColumnResizer from "react-table-column-resizer";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useSortable } from "@dnd-kit/sortable";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import CurrencyInput from "react-currency-input-field";
import { CSS } from "@dnd-kit/utilities";
import DeleteIcon from "@mui/icons-material/Delete";
import Avatar from "@mui/material/Avatar";
import InfoIcon from "@mui/icons-material/Info";
import { getAllDataQuotation, clearGetAllDataQuotation } from "../../redux/handlers/quotation/getAllDataQuotation.handler";
import { getAllDataQuotationExcel, clearGetAllDataQuotationExcel } from "../../redux/handlers/quotation/getAllDataQuotationExcel.handler";
import { updateQuotationDel, clearUpdateQuotationDel } from "../../redux/handlers/quotation/updateQuotationDel.handler";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
export function Quotation() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), tableData = _useState[0], setTableData = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), excelTotal = _useState1[0], setExcelTotal = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), excelLoaded = _useState2[0], setExcelLoaded = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), excelLoadData = _useState3[0], setExcelLoadData = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), excelData = _useState4[0], setExcelData = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), filterText = _useState5[0], setFilterText = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), filteredItems = _useState6[0], setFilteredItems = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), tabStatus = _useState7[0], setTabStatus = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), rowCtId = _useState8[0], setRowCtId = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), rowCtCode = _useState9[0], setRowCtCode = _useState9[1];
    var _useState10 = _sliced_to_array(useState(false), 2), reData = _useState10[0], setReData = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), statusCt = _useState11[0], setStatusCt = _useState11[1];
    var _useState12 = _sliced_to_array(useState(1), 2), pageId = _useState12[0], setPageId = _useState12[1];
    var _useState13 = _sliced_to_array(useState(10), 2), pageSize = _useState13[0], setPageSize = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), sortModel = _useState14[0], setSortModel = _useState14[1];
    var _useState15 = _sliced_to_array(useState(false), 2), loading = _useState15[0], setLoading = _useState15[1];
    var _useState16 = _sliced_to_array(useState(0), 2), totalPage = _useState16[0], setTotalPage = _useState16[1];
    var _useState17 = _sliced_to_array(useState(0), 2), totalAmount = _useState17[0], setTotalAmount = _useState17[1];
    var _useState18 = _sliced_to_array(useState(""), 2), sDate = _useState18[0], setSDate = _useState18[1];
    var _useState19 = _sliced_to_array(useState(""), 2), eDate = _useState19[0], setEDate = _useState19[1];
    var _useState20 = _sliced_to_array(useState(""), 2), paymentId = _useState20[0], setPaymentId = _useState20[1];
    var _useState21 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState21[0], setModalsuccess = _useState21[1];
    var _useState22 = _sliced_to_array(useState(false), 2), delCtShow = _useState22[0], setDelCtShow = _useState22[1];
    var handleDelCtShowShow = function() {
        return setDelCtShow(true);
    };
    var handleDelCtClose = function() {
        return setDelCtShow(false);
    };
    var getAllDataQuotationReducer = useAppSelector(function(state) {
        return state.getAllDataQuotationReducer;
    });
    var getAllDataQuotationExcelReducer = useAppSelector(function(state) {
        return state.getAllDataQuotationExcelReducer;
    });
    var optionsMstPayment = [
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "โอนธนาคาร"
        },
        {
            value: 3,
            label: "เช็คเงินสด"
        }
    ];
    useEffect(function() {
        var data = _object_spread({
            pageId: pageId,
            pageSize: pageSize
        }, sDate && {
            sDate: moment(sDate).format("YYYY-MM-DD")
        }, eDate && {
            eDate: moment(eDate).format("YYYY-MM-DD")
        }, tabStatus && {
            status: parseInt(tabStatus)
        }, filterText && {
            filterText: filterText
        }, paymentId && {
            paytype: paymentId
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        });
        dispatch(getAllDataQuotation(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        pageId,
        pageSize,
        sortModel,
        filterText,
        tabStatus,
        paymentId,
        sDate,
        eDate
    ]);
    var columns = [
        {
            name: "เลขที่ใบเสนอราคา",
            selector: function(row) {
                return row.qr_quotation_code;
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "qr_quotation_code",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/quotation/edit/" + row.qr_quotation_id,
                        children: row.qr_quotation_code ? row.qr_quotation_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "หมายเลขสัญญา",
            selector: function(row) {
                return row.ct_contract_code;
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "ct_contract_code",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_contract/new/edit/" + row.qr_quotation_contid,
                        children: row.ct_contract_code ? row.ct_contract_code : "-"
                    })
                });
            }
        },
        {
            name: "เลขที่อ้างอิง",
            selector: function(row) {
                return row.qr_quotation_refercode;
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "qr_quotation_refercode",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/quotation/edit/" + row.qr_quotation_id,
                        children: row.qr_quotation_refercode ? row.qr_quotation_refercode : "-"
                    })
                });
            }
        },
        {
            name: "ชื่อลูกค้า",
            selector: function(row) {
                return row.qr_quotation_name;
            },
            sortable: true,
            sortField: "qr_quotation_name",
            //width: "300px",
            cell: function(row) {
                return row.qr_quotation_businesstype == 2 ? /*#__PURE__*/ _jsx("div", {
                    children: row.qr_quotation_name && row.qr_quotation_name != "" && row.qr_quotation_name != null ? row.qr_quotation_comprefixname + row.qr_quotation_name + row.qr_quotation_suffixname : "-"
                }) : row.qr_quotation_businesstype == 1 ? /*#__PURE__*/ _jsx("div", {
                    children: row.qr_quotation_fname && row.qr_quotation_fname != "" && row.qr_quotation_fname != null ? getPrefixName(row.qr_quotation_prefixid) + row.qr_quotation_fname + " " + row.qr_quotation_lname : "-"
                }) : /*#__PURE__*/ _jsx(_Fragment, {
                    children: "-"
                });
            }
        },
        {
            name: "วันที่ออกเอกสาร",
            selector: function(row) {
                return row.qr_quotation_issuedate;
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "qr_quotation_issuedate",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.qr_quotation_issuedate && row.qr_quotation_issuedate != "" && row.qr_quotation_issuedate != null ? moment(row.qr_quotation_issuedate).format("DD/MM/YYYY") : "-"
                });
            }
        },
        {
            name: "วันที่เอกสารหมดอายุ",
            selector: function(row) {
                return row.qr_quotation_expiredate;
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "qr_quotation_expiredate",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.qr_quotation_expiredate && row.qr_quotation_expiredate != "" && row.qr_quotation_expiredate != null ? moment(row.qr_quotation_expiredate).format("DD/MM/YYYY") : "-"
                });
            }
        },
        {
            name: "ประเภทการชำระเงิน",
            selector: function(row) {
                return row.qr_quotation_paytype_text;
            },
            sortable: true,
            sortField: "qr_quotation_paytype",
            center: "true",
            width: "200px",
            cell: function(row) {
                return row.qr_quotation_paytype_text ? row.qr_quotation_paytype_text : "-";
            }
        },
        {
            name: "มูลค่าสุทธิ",
            selector: function(row) {
                return row.qr_quotation_totalnet;
            },
            sortable: true,
            sortField: "qr_quotation_totalnet",
            width: "150px",
            center: true,
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.qr_quotation_totalnet && row.qr_quotation_totalnet != "" && row.qr_quotation_totalnet != null && row.qr_quotation_totalnet > 0 ? /*#__PURE__*/ _jsx(NumericFormat, {
                        value: row.qr_quotation_totalnet,
                        thousandSeparator: ",",
                        decimalScale: 2,
                        fixedDecimalScale: true,
                        displayType: "text"
                    }) : "0.00"
                });
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.qr_quotation_status;
            },
            sortable: true,
            sortField: "qr_quotation_status",
            center: "true",
            width: "150px",
            cell: function(row) {
                return row.qr_quotation_status == 6 ? /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "py-1 px-2 text-center mx-auto",
                            style: {
                                color: "#6f42c1",
                                backgroundColor: "#e2d9f3",
                                borderRadius: "20px",
                                width: "130px"
                            },
                            children: row.qr_quotation_status_text
                        })
                    })
                }) : row.qr_quotation_status == 4 || row.qr_quotation_status == 5 ? /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "py-1 px-2 text-center mx-auto",
                            style: {
                                color: "rgba(211, 47, 47, 1)",
                                backgroundColor: "rgba(253, 237, 237, 1)",
                                borderRadius: "20px",
                                width: "130px"
                            },
                            children: row.qr_quotation_status_text
                        })
                    })
                }) : row.qr_quotation_status == 3 ? /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "py-1 px-2 text-center mx-auto",
                            style: {
                                color: "rgba(255, 255, 255, 1)",
                                backgroundColor: "rgba(16, 176, 42, 1)",
                                borderRadius: "20px",
                                width: "130px"
                            },
                            children: row.qr_quotation_status_text
                        })
                    })
                }) : row.qr_quotation_status == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.qr_quotation_status_text
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: row.qr_quotation_status_text
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.qr_quotation_id;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Stack, {
                    direction: "horizontal",
                    gap: 2,
                    sx: {
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: row.qr_quotation_id && row.qr_quotation_status < 2 ? /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "m-0 py-0",
                            onClick: function() {
                                return handleDeleteRow(row.qr_quotation_id, row.qr_quotation_code);
                            },
                            children: /*#__PURE__*/ _jsx(Avatar, {
                                sx: {
                                    color: "rgba(176,4,18,1)",
                                    bgcolor: "rgba(246,225,227,1)",
                                    fontSize: 30
                                },
                                children: /*#__PURE__*/ _jsx(DeleteIcon, {
                                    fontSize: "inherit"
                                })
                            })
                        })
                    }) : "-"
                });
            },
            center: "true",
            width: "100px"
        }
    ];
    var handleSearchList = function() {
        var statusList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, filterText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        setIsLoading(true);
        dispatch(getAllDataQuotation({
            status: statusList && statusList > 0 ? parseInt(statusList, 10) : 0,
            quotationcode: filterText && filterText != null && filterText != "" ? filterText : ""
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        setStatusCt(statusList);
    };
    var handleDeleteRow = function() {
        var rowId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", rowCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (rowId && rowId != "" && rowId != null) {
            setRowCtId(rowId);
            setRowCtCode(rowCode);
            handleDelCtShowShow();
        }
    };
    // const getData = () => {
    //   dispatch(
    //     getAllDataQuotation(
    //       {
    //         status: 0,
    //         quotationcode: "",
    //       },
    //       { modalObj, setModalObj },
    //     ),
    //   );
    // };
    useEffect(function() {
        setIsLoading(getAllDataQuotationReducer.isFetching);
        setLoading(getAllDataQuotationReducer.isFetching);
        if (getAllDataQuotationReducer.data && !getAllDataQuotationReducer.isError) {
            var _getAllDataQuotationReducer_data_data, _getAllDataQuotationReducer_data;
            var data = getAllDataQuotationReducer.data.data;
            var pagination = getAllDataQuotationReducer === null || getAllDataQuotationReducer === void 0 ? void 0 : (_getAllDataQuotationReducer_data = getAllDataQuotationReducer.data) === null || _getAllDataQuotationReducer_data === void 0 ? void 0 : (_getAllDataQuotationReducer_data_data = _getAllDataQuotationReducer_data.data) === null || _getAllDataQuotationReducer_data_data === void 0 ? void 0 : _getAllDataQuotationReducer_data_data.pagination;
            setTableData(data.data);
            setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
            setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
            setExcelData([]);
            setExcelTotal((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
            setExcelLoaded(true);
            dispatch(clearGetAllDataQuotationExcel());
        }
    }, [
        getAllDataQuotationReducer
    ]);
    useEffect(function() {
        if (excelLoaded && excelTotal) {
            setExcelLoaded(false);
            var dataExcel = _object_spread({
                pageId: 1,
                pageSize: excelTotal
            }, sDate && {
                sDate: moment(sDate).format("YYYY-MM-DD")
            }, eDate && {
                eDate: moment(eDate).format("YYYY-MM-DD")
            }, tabStatus && {
                status: parseInt(tabStatus)
            }, filterText && {
                filterText: filterText
            }, paymentId && {
                paytype: paymentId
            }, sortModel && {
                sortField: sortModel.sortField,
                sortValue: sortModel.sortValue
            });
            dispatch(getAllDataQuotationExcel(dataExcel, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        excelTotal,
        excelLoaded
    ]);
    useEffect(function() {
        setExcelLoadData(getAllDataQuotationExcelReducer.isFetching);
        if (getAllDataQuotationExcelReducer.data && !getAllDataQuotationExcelReducer.isError) {
            var tableExcel = getAllDataQuotationExcelReducer.data.data;
            if (tableExcel && (tableExcel === null || tableExcel === void 0 ? void 0 : tableExcel.data.length) && (tableExcel === null || tableExcel === void 0 ? void 0 : tableExcel.data.length) > 0) {
                tableExcel === null || tableExcel === void 0 ? void 0 : tableExcel.data.map(function(item, index) {
                    if (item.qr_quotation_id && item.qr_quotation_id != "" && item.qr_quotation_id > 0) {
                        setExcelData(function(excelData) {
                            return _to_consumable_array(excelData).concat([
                                {
                                    "ลำดับ": index + 1,
                                    "เลขที่ใบเสนอราคา": item.qr_quotation_code || "-",
                                    "หมายเลขสัญญา": item.ct_contract_code || "-",
                                    "เลขที่อ้างอิง": item.qr_quotation_refercode || "-",
                                    "ชื่อลูกค้า": item.qr_quotation_name ? item.qr_quotation_businesstype == 2 ? item.qr_quotation_comprefixname + item.qr_quotation_name + item.qr_quotation_suffixname : item.qr_quotation_fname ? getPrefixName(item.qr_quotation_prefixid) + item.qr_quotation_fname + " " + item.qr_quotation_lname : "-" : "-",
                                    "วันที่ออกเอกสาร": item.qr_quotation_issuedate ? moment(item.qr_quotation_issuedate).format("DD/MM/YYYY") : "-",
                                    "วันที่เอกสารหมดอายุ": item.qr_quotation_expiredate ? moment(item.qr_quotation_expiredate).format("DD/MM/YYYY") : "-",
                                    "ประเภทการชำระเงิน": item.qr_quotation_paytype_text || "-",
                                    "มูลค่าสุทธิ": item.qr_quotation_totalnet && item.qr_quotation_totalnet != "" && item.qr_quotation_totalnet != null && item.qr_quotation_totalnet > 0 ? item.qr_quotation_totalnet : "0.00",
                                    "สถานะ": item.qr_quotation_status_text || "-"
                                }
                            ]);
                        });
                    }
                });
            }
        }
    }, [
        getAllDataQuotationExcelReducer
    ]);
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบเสนอราคา"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "ใบเสนอราคา"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        defaultActiveKey: tabStatus,
                        onSelect: function(selectedKey) {
                            setTabStatus(selectedKey);
                            handleSearchList(parseInt(selectedKey - 1, 10), filterText);
                            setStatusCt(parseInt(selectedKey - 1, 10));
                        },
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "0",
                                    children: "ทั้งหมด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "1",
                                    children: "แบบร่าง"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "2",
                                    children: "รออนุมัติ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "3",
                                    children: "อนุมัติแล้ว"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "4",
                                    children: "ไม่อนุมัติ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "7",
                                    children: "หมดอายุ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "6",
                                    children: "ยกเลิก"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Card, {
                        children: [
                            /*#__PURE__*/ _jsx(CardBody, {
                                children: /*#__PURE__*/ _jsxs(Row, {
                                    className: "align-items-center justify-content-between",
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: "auto",
                                            className: "mb-2",
                                            children: /*#__PURE__*/ _jsx(DownloadExcelLoading, {
                                                data: excelData,
                                                filename: "quotation_" + moment().format("YYYYMMDDHHmmss"),
                                                loading: excelLoadData
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: true,
                                            className: "mb-2",
                                            children: /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "row",
                                                spacing: 1,
                                                sx: {
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "วันที่ออกเอกสาร"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "w-[330px]",
                                                        children: /*#__PURE__*/ _jsx(DatePicker, {
                                                            selected: sDate,
                                                            onChange: function(date) {
                                                                return setSDate(date);
                                                            },
                                                            dateFormat: "dd-MM-yyyy",
                                                            className: "form-control",
                                                            isClearable: true
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: true,
                                            className: "mb-2",
                                            children: /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "row",
                                                spacing: 1,
                                                sx: {
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "ถึง"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "w-[330px]",
                                                        children: /*#__PURE__*/ _jsx(DatePicker, {
                                                            selected: eDate,
                                                            onChange: function(date) {
                                                                return setEDate(date);
                                                            },
                                                            dateFormat: "dd-MM-yyyy",
                                                            className: "form-control",
                                                            isClearable: true
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: true,
                                            className: "mb-2",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "form-st-3 p-0 my-0",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1 z-3",
                                                        children: "ประเภทการชำระเงิน"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        className: "w-100 select-st-3 z-2",
                                                        placeholder: "ประเภทการชำระเงิน",
                                                        options: optionsMstPayment,
                                                        value: optionsMstPayment.find(function(opt) {
                                                            return opt.value === paymentId;
                                                        }) || "",
                                                        onChange: function(e) {
                                                            return setPaymentId(e ? e.value : "");
                                                        },
                                                        isClearable: true
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: true,
                                            className: "mb-2",
                                            children: /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                className: "form-control form-200",
                                                placeholder: "ค้นหาเลขที่ใบเสนอราคา, เลขที่อ้างอิง,ชื่อลูกค้า",
                                                onKeyUp: function(e) {
                                                    setFilterText(e.target.value);
                                                    handleSearchList(statusCt, e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: "auto",
                                            className: "mb-2",
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                className: "btn-st-7 px-2",
                                                href: "/quotation/create",
                                                variant: "",
                                                style: {
                                                    minWidth: 200
                                                },
                                                children: "สร้างใบเสนอราคา"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                                item: tableData,
                                columns: columns,
                                isSelectRows: false,
                                currentPage: pageId,
                                currentPageSize: pageSize,
                                onChangePage: handleChangePage,
                                onChangePageSize: handleChangeRowsPerPage,
                                totalPage: totalPage,
                                totalAmount: totalAmount,
                                sortModel: sortModel,
                                onChangeSort: setSortModel,
                                handleSort: handleSort,
                                loading: loading
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DeleteModal, {
                show: delCtShow,
                onHide: handleDelCtClose,
                rowCtId: rowCtId,
                rowCtCode: rowCtCode,
                setReData: setReData,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
function DeleteModal(_param) {
    var rowCtId = _param.rowCtId, rowCtCode = _param.rowCtCode, props = _object_without_properties(_param, [
        "rowCtId",
        "rowCtCode"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var contractID = useParams().contractID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var updateQuotationDelReducer = useAppSelector(function(state) {
        return state.updateQuotationDelReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        if (rowCtId && rowCtId != "" && rowCtId > 0) {
            setIsLoading(true);
            var payload = {
                quotationid: parseInt(rowCtId, 10)
            };
            dispatch(updateQuotationDel(payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณาเลือกรายการที่ต้องการลบ"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateQuotationDelReducer.isFetching);
        if (rowCtId && rowCtId != "" && rowCtId != null) {
            if (updateQuotationDelReducer.data && !updateQuotationDelReducer.isError) {
                var updatedData = updateQuotationDelReducer.data.data;
                dispatch(clearUpdateQuotationDel());
            }
        }
        if (isBoxAlert) {
            props.setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ลบรายการเลขที่ใบเสนอราคา " + rowCtCode + " เรียบร้อย",
                    direction: ""
                });
            });
            setIsBoxAlert(false);
            props.setReData(true);
        }
    }, [
        updateQuotationDelReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ลบรายการ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะลบใบเสนอราคาเลขที่ ",
                                rowCtCode,
                                " หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ตกลง"
                    })
                ]
            })
        ]
    }));
}
